import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import transition from "~/utilities/transition";

import BaseLink from "~/components/links/BaseLink";

import ProductFlag from "~/components/ProductFlag";

import { sanitizeAndParseHTML } from "~/utilities/helpers";
import { trackCustomGA4Event } from "~/utilities/trackCustomEvent";

const Text = styled.div`
    display: flex;
    align-items: center;
    font-weight: 700;
    gap: 1rem;
`;

const PaddedText = styled.div`
    display: flex;
    align-items: center;
    font-weight: 700;
    padding: 15px 20px;
`;

const ProductLink = styled(BaseLink)`
    ${transition({}, "color")};
    padding: ${({ isDeviceSkus }) => (isDeviceSkus ? "5px 0" : "0")};
    color: ${({ theme }) => theme.colors.typography.links};
    font-weight: 700;
    display: flex;
    align-items: center;

    &:hover,
    &:focus {
        color: ${({ theme }) => theme.colors.typography.linksHover};
        outline-color: ${({ theme }) => theme.palette.productLinkFocus};
        outline-offset: -3px;
    }
`;

const isLink = (linkProduct, urlOverride, productUrl) => {
    return linkProduct && (urlOverride || productUrl);
};

const ProductTableLink = ({
    primaryCategory,
    subcategory,
    productUrl = "",
    urlOverride,
    linkProduct = false,
    productFlags = [],
    text = "",
    isDeviceSkus = false,
}) => {
    const label = sanitizeAndParseHTML(text);

    return isLink(linkProduct, urlOverride, productUrl) ? (
        <Text>
            <ProductLink
                isDeviceSkus={isDeviceSkus}
                to={urlOverride || productUrl}
                onClick={() =>
                    trackCustomGA4Event("dataTableProductClick", {
                        product: label,
                    })
                }
                state={{
                    primaryCategory,
                    subcategory,
                }}
            >
                {label}
            </ProductLink>
            {productFlags?.length
                ? productFlags.map(({ badgeName, dateType, date }, index) =>
                      date ? (
                          <ProductFlag
                              key={`fl-${badgeName}-${date}-${index}`}
                              {...{ badgeName, dateType, date }}
                          />
                      ) : null,
                  )
                : null}
        </Text>
    ) : (
        <PaddedText>
            {label}
            {productFlags?.length
                ? productFlags.map(({ badgeName, dateType, date }, index) =>
                      date ? (
                          <ProductFlag
                              key={`fl-${badgeName}-${date}-${index}`}
                              {...{ badgeName, dateType, date }}
                          />
                      ) : null,
                  )
                : null}
        </PaddedText>
    );
};

ProductTableLink.propTypes = {
    languageCode: PropTypes.string,
    linkProduct: PropTypes.bool,
    slug: PropTypes.string,
    productFlags: PropTypes.arrayOf(PropTypes.shape({})),
    text: PropTypes.string,
    urlOverride: PropTypes.string,
    productUrl: PropTypes.string,
    isDeviceSkus: PropTypes.bool,
};

export default ProductTableLink;
